import { type ReactNode } from 'react'

import { Link } from 'react-router-dom'

import { IconCaretSm } from 'assets/svg/sprite'
import { IconButton } from 'components/IconButton/IconButton'

import styles from './mediaSection.module.scss'

interface Props {
    icon: JSX.Element
    title: string
    action: string
    hasData: boolean
    children: ReactNode
    customClass?: string
}

export const MediaSection = ({
    children,
    title,
    icon,
    action,
    hasData,
    customClass = '',
}: Props) => {
    return (
        <div
            className={`${styles.wrapper} ${
                hasData ? styles['wrapper-withcontent'] : ''
            } ${customClass}`}
        >
            <div className={styles.header}>
                <div className={styles.sectionTitle}>
                    <div className={styles.icon}>{icon}</div>

                    {/* Wrap the title in a Link */}
                    <Link to={action} className={styles.titleLink}>
                        <div className={styles.title}>{title}</div>
                    </Link>
                </div>

                {hasData && (
                    <Link to={action} className={styles.action}>
                        <div className={styles.text}>View All</div>
                        <div className={styles.button}>
                            <IconButton
                                icon={<IconCaretSm />}
                                size="small"
                                type="lightGrey"
                            />
                        </div>
                    </Link>
                )}
            </div>

            <div className={styles.content}>{children}</div>
        </div>
    )
}
